/* tslint:disable */
/* eslint-disable */
/**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { SignupAuthTokenToken } from './SignupAuthTokenToken';
import {
    SignupAuthTokenTokenFromJSON,
    SignupAuthTokenTokenFromJSONTyped,
    SignupAuthTokenTokenToJSON,
} from './SignupAuthTokenToken';

/**
 * 
 * @export
 * @interface SignupAuthToken
 */
export interface SignupAuthToken {
    /**
     * 
     * @type {SignupAuthTokenToken}
     * @memberof SignupAuthToken
     */
    token: SignupAuthTokenToken;
    /**
     * 
     * @type {string}
     * @memberof SignupAuthToken
     */
    userId: string;
    /**
     * 
     * @type {string}
     * @memberof SignupAuthToken
     */
    email: string;
    /**
     * 
     * @type {Array<any>}
     * @memberof SignupAuthToken
     */
    groups: Array<any>;
}

/**
 * Check if a given object implements the SignupAuthToken interface.
 */
export function instanceOfSignupAuthToken(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "token" in value;
    isInstance = isInstance && "userId" in value;
    isInstance = isInstance && "email" in value;
    isInstance = isInstance && "groups" in value;

    return isInstance;
}

export function SignupAuthTokenFromJSON(json: any): SignupAuthToken {
    return SignupAuthTokenFromJSONTyped(json, false);
}

export function SignupAuthTokenFromJSONTyped(json: any, ignoreDiscriminator: boolean): SignupAuthToken {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'token': SignupAuthTokenTokenFromJSON(json['token']),
        'userId': json['user_id'],
        'email': json['email'],
        'groups': json['groups'],
    };
}

export function SignupAuthTokenToJSON(value?: SignupAuthToken | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'token': SignupAuthTokenTokenToJSON(value.token),
        'user_id': value.userId,
        'email': value.email,
        'groups': value.groups,
    };
}

